'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowIconStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleIcons = require('reactackle-icons');

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  fullWidth: _propTypes2.default.bool,
  dense: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  focused: _propTypes2.default.bool,
  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success'])
};

var defaultProps = {
  fullWidth: false,
  dense: false,
  disabled: false,
  focused: false,
  colorScheme: 'neutral'
};

/** Prop Receivers */
var sizeProps = function sizeProps(_ref) {
  var dense = _ref.dense,
      fullWidth = _ref.fullWidth,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.selectBox.icon.size;
  var source = path;

  if (dense && !fullWidth) source = path.dense;else if (dense && fullWidth) source = path.denseFullWidth;else if (!dense && fullWidth) source = path.fullWidth;

  var _source = source,
      boxSize = _source.boxSize,
      imgSize = _source.imgSize;


  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(boxSize), (0, _reactackleCore.getValueString)(imgSize || boxSize), (0, _reactackleCore.getValueString)(boxSize)));
};

var styleProps = function styleProps(_ref2) {
  var themeFromProvider = _ref2.theme,
      disabled = _ref2.disabled,
      focused = _ref2.focused,
      colorScheme = _ref2.colorScheme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.selectBox.icon.state;
  var source = path[colorScheme];

  if (disabled) source = path.disabled;else if (colorScheme === 'neutral' && !focused && !disabled) source = path;else if (colorScheme === 'neutral' && focused && !disabled) source = path.focus;

  var _source2 = source,
      color = _source2.color,
      opacity = _source2.opacity;


  return '\n    &,\n    &:hover,\n    &:focus {\n      opacity: ' + opacity + ';\n      ' + (0, _reactackleIcons.iconStyleMixin)(color) + ';\n    }\n  ';
};

/** Styles */
var ArrowIconStyled = exports.ArrowIconStyled = _styledComponents2.default.span.withConfig({
  displayName: 'ArrowIconStyled'
})(['pointer-events:none;display:flex;', ' ', ' ', ';'], sizeProps, styleProps, (0, _reactackleCore.transition)('color, opacity'));

ArrowIconStyled.propTypes = propTypes;
ArrowIconStyled.defaultProps = defaultProps;
ArrowIconStyled.displayName = 'ArrowIconStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-selectbox/dist/SelectBoxCustom/styles/ArrowIconStyled.js
// module id = 790
// module chunks = 0